import React from "react";
import { Modal, Button } from "react-bootstrap";
import Swal from 'sweetalert2';

/**
 * Modal para confirmar el uso de información entregada en el sitio
 * No se puede cerrar sin confirmar
 * @param {Object} props
 * @param {boolean} props.show - Controla si el modal está visible
 * @param {Function} props.onConfirmed - Callback cuando se confirma
 * @param {boolean} props.loading - Indica si se está procesando
 */
export default function InformacionAceptadaModal({ 
  show = false,
  onConfirmed,
  loading = false
}) {

  const handleConfirmar = () => {
    if (onConfirmed) {
      onConfirmed();
    }
  };

  return (
    <Modal centered backdrop="static" keyboard={false} show={show} size="lg">
      <div className="mc-alert-modal">
        <Modal.Body style={{ padding: '40px', textAlign: 'center' }}>
          <h2 style={{ 
            fontSize: '28px', 
            fontWeight: '500', 
            color: '#333',
            marginBottom: '30px',
            lineHeight: '1.4'
          }}>
            Autorización de Uso de Datos Personales
          </h2>
          
          <p style={{ 
            textAlign: 'justify',
            fontSize: '16px',
            color: '#555',
            lineHeight: '1.6',
            marginBottom: '30px'
          }}>
            Al seleccionar "Acepto", autorizo el tratamiento de mis datos personales y/o los del pasajero que represento, exclusivamente para la gestión y prestación de los servicios asociados a la Gira de Estudios contratada a Cristour Viajes. Estos datos podrán ser compartidos con proveedores que intervengan en la ejecución de dichos servicios, conforme a lo dispuesto en la Ley N.º 19.628 sobre Protección de los Datos Personales y sus modificaciones vigentes.
          </p>
        </Modal.Body>
        
        <Modal.Footer style={{ 
          padding: '20px 40px 40px',
          border: 'none',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <Button 
            style={{
              width: '100%',
              padding: '12px 40px',
              fontSize: '16px',
              fontWeight: '500',
              backgroundColor: '#0066CC',
              borderColor: '#0066CC'
            }}
            onClick={handleConfirmar}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Procesando...
              </>
            ) : (
              "Acepto"
            )}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}
